import { Grid, Typography } from "@mui/material"
import PaperBox from "components/PaperBox"
import moment from "moment"
import { useTranslation } from "react-i18next"
import { exceptionOptions, statusOptions } from "../helpers/violationHelper"
import { IAdminViewViolationProps } from "../violation.interface"
import { Attachment } from "./Attachment"

export const ViewAdminViolation: React.FC<IAdminViewViolationProps> = (props) => {
  const { values, setFieldValue } = props
  const { t } = useTranslation("translation", { keyPrefix: "violation" })

  return (
    <PaperBox>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid item xs={12} marginBottom={2}>
            <Typography variant="h3">{t(`info_from_admin`, `Information from admin`)}</Typography>
          </Grid>

          <Grid item xs={12} marginBottom={2}>
            <Typography variant="labelMedium">{t(`updated_by_admin`, `Updated by admin`)}</Typography>
            <Typography>
              {values?.updatedDate ? moment.utc(values?.updatedDate).local().format("YYYY-MM-DD HH:mm") : "-"}
            </Typography>
          </Grid>

          <Grid item xs={12} marginBottom={2}>
            <Typography variant="labelMedium">{t(`status_title`, `Status`)}</Typography>
            <Typography variant="h5">
              {statusOptions(t)?.find((x: any) => x.id === values?.status)?.name}
            </Typography>
          </Grid>

          <Grid item xs={12} marginBottom={2}>
            <Typography variant="labelMedium">{t(`exception`, `Exception`)}</Typography>
            <Typography variant="h5">
              {exceptionOptions(t)?.find((x: any) => x.name === values?.exception)?.name}
            </Typography>
          </Grid>

          <Grid item xs={12} marginBottom={2}>
            <Typography variant="labelMedium">{t(`action_plan`, `Action plan`)}</Typography>
            <Typography variant="h5">{values?.feedback}</Typography>
          </Grid>

          <Grid item xs={12} marginBottom={2}>
            <Typography variant="labelMedium">{t(`strip`, `Does strip exists?`)}</Typography>
            <Typography variant="h5">
              {values?.updatedDate != null ? (values?.strip ? t(`yes`, `Yes`) : t(`no`, `No`)) : ""}
            </Typography>
          </Grid>

          <Grid item xs={12} marginBottom={2}>
            <Typography variant="labelMedium">{t(`driver_included`, ``)}</Typography>
            <Typography variant="h5">
              {values?.updatedDate != null ? (values?.driverIncluded ? t(`yes`, `Yes`) : t(`no`, `No`)) : ""}
            </Typography>
          </Grid>
          <Grid item xs={12} marginBottom={2}>
            <Attachment isAdmin={true} isViewing={true} values={values} setFieldValue={setFieldValue} />
          </Grid>
        </Grid>
      </Grid>
    </PaperBox>
  )
}
